import { serviceCount } from 'crm-common';

const { PAGE_NAME } = serviceCount;
const API_DOMAIN = '';

const CHART_API_CONFIG = {
  // 服务
  [PAGE_NAME.service]: {
    method: 'get',
    url: `${API_DOMAIN}/api/serviceData/query/serviceStatistics`,
  },
  // 服务 - 线上
  [PAGE_NAME.serviceOfOnline]: {
    method: 'get',
    url: `${API_DOMAIN}/api/serviceData/query/serviceCost/online`,
  },
  // 服务 - 线下
  [PAGE_NAME.serviceOfOffline]: {
    method: 'get',
    url: `${API_DOMAIN}/api/serviceData/query/serviceCost/offline`,
  },
  // 项目
  [PAGE_NAME.project]: {
    method: 'get',
    url: `${API_DOMAIN}/api/serviceData/query/projectService/statistics`,
  },
  // 项目 - 线上
  [PAGE_NAME.projectOfOnline]: {
    method: 'get',
    url: `${API_DOMAIN}/api/serviceData/query/projectService/online`,
  },
  // 项目 - 线下
  [PAGE_NAME.projectOfOffline]: {
    method: 'get',
    url: `${API_DOMAIN}/api/serviceData/query/projectService/offline`,
  },
  // 电话
  [PAGE_NAME.phone]: {
    method: 'get',
    url: `${API_DOMAIN}/api/serviceData/query/telephoneStatistics`,
  },
};

export default CHART_API_CONFIG;
